import { render, staticRenderFns } from "./ServiceOrderHeaderComponent.vue?vue&type=template&id=19e9df2c&"
import script from "./ServiceOrderHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderHeaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports